/**
 * Usercentrics Consent Handler
 * Reloads page when user denies consent to clean up blocked scripts
 * https://usercentrics.com/docs/web/features/events/uc-consent/
 */

export function initUsercentricsReload(): void {
	if (typeof window === 'undefined') {
		return;
	}

	// Listen for UC_CONSENT event
	window.addEventListener('UC_CONSENT', function(event: any) {
		if (event.detail && event.detail.consent) {
			const consent = event.detail.consent;
			
			// Only reload when user denies services (Usercentrics handles accept automatically)
			if (consent.fromUserAction && consent.updatedBy === 'onDenyAllServices') {
				location.reload();
			}
		}
	});
}